namespace RioERP.Orders {
    export interface OrderProductsForm {
        OrderId: Serenity.LookupEditor;
        ProductId: Serenity.LookupEditor;
        OrderProductSpecificationId: Serenity.LookupEditor;
        Quantity: Serenity.IntegerEditor;
        Cost: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        DiscountAmt: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        NetAmountAfterFrDiscount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        OrderESourceType: Serenity.IntegerEditor;
        HasPendrive: Serenity.BooleanEditor;
        HasBooks: Serenity.BooleanEditor;
        HasCourier: Serenity.BooleanEditor;
        IsLive: Serenity.BooleanEditor;
        SerialKey: Serenity.StringEditor;
        ESerialkeyStatus: Serenity.EnumEditor;
        DownloadUrl1: Serenity.StringEditor;
        DownloadUrl2: Serenity.StringEditor;
        InvoiceCompanyId: Serenity.LookupEditor;
        EOpens: Serenity.EnumEditor;
        EWatchTime: Serenity.EnumEditor;
        EValidityType: Serenity.EnumEditor;
        EValidity: Serenity.EnumEditor;
        ValidTill: Serenity.DateEditor;
        TotalAllowedDuration: Serenity.IntegerEditor;
        AllowedDevice: Serenity.LookupEditor;
        EAccessStatus: Serenity.EnumEditor;
        IsTemplateSerialKey: Serenity.BooleanEditor;
        Note: Serenity.StringEditor;
        Rioplay8ProductCode: Serenity.StringEditor;
        Rioplay8ESubscriptionType: Serenity.EnumEditor;
        Rioplay8ValidityInDays: Serenity.IntegerEditor;
        Rioplay8ValidDate: Serenity.DateEditor;
        Rioplay8EViewsType: Serenity.EnumEditor;
        Rioplay8ViewsPerContent: Serenity.IntegerEditor;
        Rioplay8EWatchTimetype: Serenity.EnumEditor;
        Rioplay8WatchTime: Serenity.DecimalEditor;
        Rioplay8AllowedDevices: Serenity.StringEditor;
        Rioplay8EDeviceRestrictionType: Serenity.EnumEditor;
        Rioplay8DeviceCount: Serenity.IntegerEditor;
        Rioplay8SwitchCount: Serenity.IntegerEditor;
        Rioplay8TenantId: Serenity.StringEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
        FranchiseeDiscountValue: Serenity.DecimalEditor;
        EFranchiseeDiscountType: Serenity.EnumEditor;
    }

    export class OrderProductsForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrderProducts';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderProductsForm.init)  {
                OrderProductsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.StringEditor;
                var w5 = s.EnumEditor;
                var w6 = s.DateEditor;

                Q.initFormType(OrderProductsForm, [
                    'OrderId', w0,
                    'ProductId', w0,
                    'OrderProductSpecificationId', w0,
                    'Quantity', w1,
                    'Cost', w2,
                    'GrossAmount', w2,
                    'DiscountAmt', w2,
                    'NetAmount', w2,
                    'NetAmountAfterFrDiscount', w2,
                    'TaxableAmount', w2,
                    'TaxAmount', w2,
                    'OrderESourceType', w1,
                    'HasPendrive', w3,
                    'HasBooks', w3,
                    'HasCourier', w3,
                    'IsLive', w3,
                    'SerialKey', w4,
                    'ESerialkeyStatus', w5,
                    'DownloadUrl1', w4,
                    'DownloadUrl2', w4,
                    'InvoiceCompanyId', w0,
                    'EOpens', w5,
                    'EWatchTime', w5,
                    'EValidityType', w5,
                    'EValidity', w5,
                    'ValidTill', w6,
                    'TotalAllowedDuration', w1,
                    'AllowedDevice', w0,
                    'EAccessStatus', w5,
                    'IsTemplateSerialKey', w3,
                    'Note', w4,
                    'Rioplay8ProductCode', w4,
                    'Rioplay8ESubscriptionType', w5,
                    'Rioplay8ValidityInDays', w1,
                    'Rioplay8ValidDate', w6,
                    'Rioplay8EViewsType', w5,
                    'Rioplay8ViewsPerContent', w1,
                    'Rioplay8EWatchTimetype', w5,
                    'Rioplay8WatchTime', w2,
                    'Rioplay8AllowedDevices', w4,
                    'Rioplay8EDeviceRestrictionType', w5,
                    'Rioplay8DeviceCount', w1,
                    'Rioplay8SwitchCount', w1,
                    'Rioplay8TenantId', w4,
                    'FranchiseeDiscountAmount', w2,
                    'FranchiseeDiscountValue', w2,
                    'EFranchiseeDiscountType', w5
                ]);
            }
        }
    }
}
